import React from 'react';
import * as S from './AdCardNew.styled';
import { AdKind } from '@/api/types/common.types';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { KIND_ICON_NAMES } from '@/components/KindIcons/KindIcons.constants';

interface LindListProps {
  kinds?: AdKind[];
}

export const LindList = ({ kinds }: LindListProps) => {
  return (
    <S.KindsList>
      {kinds?.map(kind => {
        const icon = KIND_ICON_NAMES[kind];

        if (!icon) return null;

        return (
          <IconBox
            key={kind}
            $filename={`${icon}.svg`}
            $iconWidth={16}
            $iconHeight={12}
            data-testid="ServiceIcon"
          />
        );
      })}
    </S.KindsList>
  );
};
